import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { useTheme } from 'styled-components';
import TooltipInfo from './TooltipInfo';
import CopyToClipboardIcon from './CopyToClipboardIcon';

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 5px;
  padding: 5px;
`;

const StyledLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.foreground.tint};
  white-space: nowrap;
`;

const CopyableUserDetails = ({
  number,
  name,
}: {
  number: string;
  name: string;
}) => {
  const theme = useTheme();
  if (!number) {
    return <span>-</span>;
  }

  const telLink = `tel:${number.replace(/\s+/g, '')}`;

  return (
    <TooltipInfo
      closeOnLeave={false}
      icon={faPhoneAlt}
      color={theme.colors.foreground.tint}
      title={`Ring ${number}`}
      info={
        <Content>
          <span>{name}</span>
          <CopyToClipboardIcon copyableText={name} />
          <StyledLink href={telLink} title={`Ring ${number}`}>
            {number}
            <FontAwesomeIcon icon={faPhoneAlt} style={{ marginLeft: 5 }} />
          </StyledLink>
          <CopyToClipboardIcon copyableText={number} />
          <span style={{ whiteSpace: 'nowrap' }}>
            {name} {number}
          </span>
          <CopyToClipboardIcon copyableText={`${name} ${number}`} />
        </Content>
      }
    />
  );
};

export default CopyableUserDetails;
